import angular from 'angular'


import { EditEventHostComponent } from './edit-event-host.component';
import { EventHostListComponent } from './event-host-list.component';

import { SharedModule } from '../shared/shared.module'
import { EventHostDetailComponent } from './event-host-detail.component';

export const EventHostModule = angular
    .module("apex.mainApp.eventHost", [
        SharedModule
    ])
    .component("apexEditEventHost", EditEventHostComponent)
    .component("apexEventHostDetail", EventHostDetailComponent)
    .component("apexEventHostList", EventHostListComponent)
    .name;
